import React, { FC } from 'react';

import { AccessibilityCriticalIssuesStackedChart } from './AccessibilityCriticalIssuesStackedChart';
import { ChartIssuesInput } from './types';

interface AccessibilityCriticalIssuesStackedChartContainerProps {
	data?: ChartIssuesInput;
	uniqueIssuesData?: ChartIssuesInput;
	isLoading: boolean;
	error: unknown;
}

export const AccessibilityCriticalIssuesStackedChartContainer: FC<
	AccessibilityCriticalIssuesStackedChartContainerProps
> = ({ data, uniqueIssuesData, isLoading, error }) => {
	return (
		<AccessibilityCriticalIssuesStackedChart
			data={data}
			uniqueIssuesData={uniqueIssuesData}
			isLoading={isLoading}
			error={error ? 'Failed to load critical issues data' : null}
		/>
	);
};
